
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWindTrue7 as ObiWindTrue7Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-true-7.js';
 
 
 

 
 export const ObiWindTrue7 = createComponent({
   react: React,
   tagName: 'obi-wind-true-7',
   elementClass: ObiWindTrue7Element,
   events: {
     
   }
  });
 
 